<script>

export default {
    name: "InputCheckbox",

    emits: ['change', 'update:model-value'],

    props: {
        checked: {
            type: Object,
            default: []
        },

        filterName: {
          type: String,
          required: true
        },

        disabled: {
            type: Boolean,
            default: false
        },

        icon : {
            type: String,
            default: ''
        },

        id : {
            type:[ Number, String],
        },

        label : {
            type: String,
        },

        suffix : {
            type: String,
        },

        type : {
            type: String,
        },

        value : {
            type: [String, Boolean],
        },
    },

    data() {
        return {
            vModel : null
        }
    },

    // model: {
    //     prop: 'checked',
    //     event: 'change'
    // },

    computed: {
        disabledClass(){
            return this.disabled ? 'grayed-out' : '';
        },
        isChecked(){
            return this.checked.includes(this.value);
        },
        fakeCheckboxClass(){
            return this.isChecked ?
                'filters__fake-checkbox default-checkbox default-checkbox--active' :
                'filters__fake-checkbox default-checkbox';
        },
        labelClass(){
            if(this.isCheckbox){
                return this.disabled ?
                    'filters__label grayed-out cursor-text':
                    'filters__label';
            }

            if(this.isTag){
                return this.isChecked ?
                    'tag tag--active' :
                    'tag';
            }
        },
        isCheckbox(){
            return this.type === "checkbox";
        },
        isTag(){
            return this.type === "tag";
        }
    },

    methods: {
        valueChanged(event) {
            let isChecked = event.target.checked;

            let newValue = [...this.checked]

            if (isChecked) {
                // console.log('push');
                newValue.push(this.value)
            } else {
                // console.log('remove');
                newValue.splice(newValue.indexOf(this.value), 1)
            }

            this.$emit('change', this.filterName, newValue);
        },
    },
}

</script>

<template>
    <label :class="labelClass" :for="id">
        <span v-if="isCheckbox" :class="fakeCheckboxClass">
           <span v-if="isChecked" v-html="icon"></span>
        </span>
        <input
               type="checkbox"
               :checked="isChecked"
               :value="value"
               :id="id"
               :name="id"
               @change="valueChanged">
        {{label}}
        <span v-if="suffix" class="ml-1">{{suffix}}</span>
    </label>
</template>